import GameStatesEnum from "@/states/GameStatesEnum";
import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";

export default class InitState extends BaseState {

  begin() {
    Signals.initGame.add(this.onInitGame, this)
    Signals.gameMessage.dispatch({message: 'auth'})
  }

  onInitGame(data) {
    this.model.initRawData = data
    // this.stateMachine.setState(GameStatesEnum.IDLE)
  }

  cleanUp() {
    Signals.initGame.remove(this.onInitGame, this)
  }

}
